import { render, staticRenderFns } from "./PromotionCard.vue?vue&type=template&id=24644836&scoped=true&"
import script from "./PromotionCard.vue?vue&type=script&lang=js&"
export * from "./PromotionCard.vue?vue&type=script&lang=js&"
import style0 from "./PromotionCard.vue?vue&type=style&index=0&id=24644836&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24644836",
  null
  
)

export default component.exports